/**
 * Venus Jewelry — Envío gratis por producto (ej. Brazaletes Magnéticos).
 *
 * Shopify no permite condicionar un descuento de envío gratis a un producto, así
 * que hay un código de envío gratis (Ajustes del tema → Venus — Carrito) que este
 * script pone en el carrito mientras haya un producto con la etiqueta
 * "envio-gratis", y quita en cuanto ya no lo hay.
 *
 * El código NO va en todas las páginas: cart-summary.liquid lo pinta en
 * data-cart-free-shipping solo cuando el carrito trae un producto con la etiqueta
 * (y product-hero.liquid en la página de ese producto, para "Comprar ahora").
 * Se recuerda en localStorage para poder quitarlo cuando el producto sale del
 * carrito (en ese momento ya no viene en el HTML).
 *
 * Se revisa al cargar y después de cada re-render del carrito (cart:html-updated).
 * Los códigos actuales se leen de /cart.js (no de las píldoras del carrito):
 * Shopify no pinta los códigos de envío como píldora hasta el checkout.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'vj-free-ship-code';

  function remember(code) {
    try { localStorage.setItem(STORAGE_KEY, code); } catch (e) { /* modo privado */ }
  }

  function remembered() {
    try { return localStorage.getItem(STORAGE_KEY) || ''; } catch (e) { return ''; }
  }

  /** Código pintado en el carrito actual ('' si no hay producto con envío gratis). */
  function renderedCode() {
    var el = document.querySelector('[data-cart-total-cents][data-cart-free-shipping]');
    return el ? (el.getAttribute('data-cart-free-shipping') || '').trim() : '';
  }

  function run(fn) {
    return window.VJCartQueue ? window.VJCartQueue.run(fn) : fn();
  }

  /**
   * Pone o quita el código.
   * @param {boolean} [wanted] — si no se pasa, se decide con el carrito renderizado.
   * @param {string} [codeOverride] — código a usar (lo pasa "Comprar ahora").
   * @returns {Promise<void>}
   */
  function sync(wanted, codeOverride) {
    var current = (codeOverride || '').trim() || renderedCode();
    if (current) remember(current);
    var code = current || remembered();
    if (!code) return Promise.resolve();

    var want = typeof wanted === 'boolean' ? wanted : !!current;
    var upper = code.toUpperCase();

    return run(function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // Carrito vacío: no hay nada que ajustar.
          if (!cart.item_count) return;

          var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
          var present = codes.some(function (c) { return c.toUpperCase() === upper; });
          if (want === present) return;

          var next = want
            ? codes.concat(code)
            : codes.filter(function (c) { return c.toUpperCase() !== upper; });

          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: next.join(',') }),
          });
        });
    }).catch(function () {
      /* sin red: se reintenta en el próximo cambio del carrito */
    });
  }

  window.vjSyncFreeShipCode = sync;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sync(); });
  } else {
    sync();
  }

  // Después de cada re-render del carrito (agregar, quitar, cambiar cantidad, descuentos).
  var timer = null;
  document.addEventListener('cart:html-updated', function () {
    clearTimeout(timer);
    timer = setTimeout(function () { sync(); }, 300);
  });
})();
